export type EliteList = {
  badges: IBadges[];
  gains_affiliate: number;
  gains_producer: number;
  sales: { affiliate: number; producer: number };
  progress: {
    affiliate: IProgress;
    producer: IProgress;
  };
  show_blackfriday_challenge: boolean;
  already_joined_blackfriday_challenge: boolean;
};

interface IProgress {
  currentGain: 0;
  next: IBadges;
  current: IBadges;
  percentageOfProgress: 0;
}

export interface IBadges {
  badge_elite: string;
  has_badge: boolean;
  has_plus: boolean;
  hint: string;
  id: number;
  name: string;
  plus: string;
  qualified_at: string;
  value_from: 0;
}

export enum BlackBelt {
  BLACK_BELT = 103,
  BLACK_BELT_D2 = 109,
  BLACK_BELT_D3 = 110,
  BLACK_BELT_D4 = 111,
  BLACK_BELT_D5 = 112,
  BLACK_BELT_D6 = 113,
  BLACK_BELT_D7 = 114,
  BLACK_BELT_D8 = 115,
  BLACK_BELT_D9 = 116,
}

export enum GoldenBelt {
  GOLDEN_BELT = 104,
  GOLDEN_BELT_D20 = 302,
  GOLDEN_BELT_D30 = 303,
  GOLDEN_BELT_D40 = 304,
  GOLDEN_BELT_D50 = 305,
  GOLDEN_BELT_D60 = 306,
  GOLDEN_BELT_D70 = 307,
  GOLDEN_BELT_D80 = 308,
  GOLDEN_BELT_D90 = 309,
}

export enum Sensei {
  SENSEI = 300,
}

export const BlackBeltOrMore = {
  ...BlackBelt,
  ...GoldenBelt,
  ...Sensei,
};

export const EliteQualification = {
  GREEN_BELT: 102,
  ...BlackBeltOrMore,
};

export const AllBeltsId = {
  RED_BELT: 100,
  ORANGE_BELT: 101,
  ...EliteQualification,
};
